// import { get } from "lodash";

export default {
  getProjectPreSales: (state) => state.projectPreSales,
  getSelectedPreSalesProject: (state) => state.projectPreSales.selectedPresaleProject,
};
